module.exports = __webpack_public_path__ + "static/media/template_s9.b97a1058.jpg";